import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSubCategoryProduct } from '../redux/actions/action-creator';
import { useParams, useSearchParams } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../Component/custombutton';
import axiosInstance from '../api/axiosInstance';
import DOMPurify from 'dompurify';
import CustomBanner from '../Component/custombaneer';
import EnquiryModal from './Products/EnquiryModal';
import INNER_BANNER from '../assets/imases/ineer_baneer.jpg';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import SorryImg from '../assets/imases/sorryimg.jpg';

const SubCategoryProduct = () => {
    const { subCategoryId } = useParams();
    const [searchParams] = useSearchParams();
    const categoryId = searchParams.get('categoryId');
    const [showModal, setShowModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState({});
    const [loading, setLoading] = useState(true);

    const dispatch = useDispatch();
    const { subcategoryproductlist } = useSelector((state) => state.common);

    useEffect(() => {
        if (subCategoryId) {
            setLoading(true);
            dispatch(getSubCategoryProduct(subCategoryId));
        }
    }, [dispatch, subCategoryId]);

    useEffect(() => {
        if (subcategoryproductlist) {
            setTimeout(() => setLoading(false), 500); // skeleton effect
        }
    }, [subcategoryproductlist]);

    const cleanDescription = (html) => {
        if (!html) return '';
        return html
            .replace(/contenteditable="false"/g, '')
            .replace(/class="ql-ui"/g, '')
            .replace(/spellcheck="false"/g, '');
    };

    const renderDescription = (description) => {
        const cleanedDescription = cleanDescription(description);
        const sanitizedDescription = DOMPurify.sanitize(cleanedDescription);
        return <div className="quill-content" dangerouslySetInnerHTML={{ __html: sanitizedDescription }} />;
    };

    const products = subcategoryproductlist || [];
    const validProducts = products.filter(item => item.name && item.image);
    const uniqueSubcategoryNames =
        validProducts.length > 0
            ? [...new Set(validProducts.map(item => item?.subcategory?.name?.trim() || 'Sub Category'))]
            : [];

    return (
        <>
            {validProducts.length > 0 && uniqueSubcategoryNames.length > 0 && (
                <CustomBanner
                    imageUrl={INNER_BANNER}
                    heading={uniqueSubcategoryNames.join(', ')}
                    links={[
                        { label: 'View All Products', path: '/workdemo/all-products' },
                        { label: 'Contact Us', path: '/workdemo/contact' }
                    ]}
                    loading={loading} // <-- poora banner skeleton ke saath
                />
            )}
            <div className='home_product'>
                <Container>
                    {validProducts.length > 0 ? (
                        // Render actual products
                        validProducts.map((item, index) => {
                            const isEven = index % 2 === 0;
                            const delay = index * 100;

                            return (
                                <div className='home_product_list' key={item._id} data-aos="fade-up" data-aos-delay={delay}>
                                    <Row>
                                        {isEven ? (
                                            <>
                                                <Col data-aos="fade-right" data-aos-delay={delay}>
                                                    <div className='home_product_list_img'>
                                                        <img src={`${axiosInstance.defaults.baseIMG}${item.image}`} alt={item.name} />
                                                    </div>
                                                </Col>
                                                <Col data-aos="fade-left" data-aos-delay={delay + 100}>
                                                    <div className='home_product_list_content'>
                                                        <h3 dangerouslySetInnerHTML={{ __html: item.name }} />
                                                        <p>{renderDescription(item.description)}</p>
                                                        <div className='home_product_list_content_btn'>
                                                            <div className='butoon_new_Add_butn'>
                                                                <Button to={`/product-details/${item._id}`} label='KNOW MORE' />
                                                            </div>
                                                            <Button
                                                                label='Enquire Now'
                                                                className='enquire-now-button'
                                                                onClick={() => {
                                                                    setSelectedProduct(item);
                                                                    setShowModal(true);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </Col>
                                            </>
                                        ) : (
                                            <>
                                                <Col data-aos="fade-left" data-aos-delay={delay + 100}>
                                                    <div className='home_product_list_content'>
                                                        <h3 dangerouslySetInnerHTML={{ __html: item.name }} />
                                                        <p>{renderDescription(item.description)}</p>
                                                        <div className='home_product_list_content_btn'>
                                                            <div className='butoon_new_Add_butn'>
                                                                <Button to={`/product-details/${item._id}`} label='KNOW MORE' />
                                                            </div>
                                                            <Button
                                                                label='Enquire Now'
                                                                className='enquire-now-button'
                                                                onClick={() => {
                                                                    setSelectedProduct(item);
                                                                    setShowModal(true);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col data-aos="fade-right" data-aos-delay={delay}>
                                                    <div className='home_product_list_img'>
                                                        <img src={`${axiosInstance.defaults.baseIMG}${item.image}`} alt={item.name} />
                                                    </div>
                                                </Col>
                                            </>
                                        )}
                                    </Row>
                                </div>
                            );
                        })
                    ) : (
                        <div className='no-products-found' style={{ textAlign: 'center', padding: '120px 0', fontSize: '1.5rem', color: '#555' }}>
                            <img
                                src={SorryImg}
                                alt="No Products Found"
                                style={{ maxWidth: '300px', width: '100%', height: 'auto' }}
                            />
                        </div>
                    )}
                    <EnquiryModal
                        show={showModal}
                        handleClose={() => setShowModal(false)}
                        productId={selectedProduct?._id}
                        productName={selectedProduct?.name}
                    />
                </Container>
            </div>
        </>
    );
};

export default SubCategoryProduct;
